import type { BlueprintTextValue } from '@/grove-blueprints/generated-types'

import type { BlueprintBindings } from '../../blueprint-bindings'

export function resolveTextValue(
  value: BlueprintTextValue,
  localizedString: (key: string) => string,
  bindingValues?: BlueprintBindings['bindingValues'],
): string {
  switch (value.type) {
    case 'literal':
      return value.value
    case 'stringKey':
      return localizedString(value.key)
    case 'binding':
      return String(bindingValues?.[value.binding] ?? value.binding)
    default:
      return ''
  }
}
